import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookSquare,
  faInstagramSquare,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";

import classes from "./Footer.module.css";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className={classes.footer}>
      <div className={classes.footerInner}>
        <div>
          <p className={classes.colTitle}>Quick Links</p>
          <ul className={classes.navList}>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about-us">About Us</Link></li>
            <li><Link to="/contact-us">Contact Us</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/gallery">Gallery</Link></li>
          </ul>
        </div>

        <div>
          <p className={classes.colTitle}>Notable Clients</p>
          <ul className={classes.clientList}>
            <li>Mandarin Oriental Hotel Group</li>
            <li>Hyatt Group</li>
            <li>Hilton Hotel Habtoor City</li>
            <li>Habtoor Grand Resort</li>
            <li>Byblos Hospitality Group</li>
            <li>Buddha-Bar Grosvenor House</li>
            <li>Capitol Hotel</li>
            <li>Little Manila Restaurant Dubai</li>
            <li>Zurich</li>
            <li>Easylease LLC</li>
            <li>Imaginary Concept LLC</li>
          </ul>
        </div>

        <div>
          <p className={classes.colTitle}>Get in Touch</p>
          <div className={classes.contactInfo}>
            <span>Industrial Area 13, Plot No 231</span>
            <span>Shed 12, Street No 13, Sharjah, U.A.E.</span>
            <a href="tel:0559744760">0559744760</a>
            <a href="mailto:info@firstnumberfurniture.com?subject=Enquiry&body=Hello,">
              info@firstnumberfurniture.com
            </a>
          </div>
          <div className={classes.socialRow}>
            <a href="https://www.facebook.com/manhattan.furniture.3" target="_blank" rel="noopener noreferrer" title="Facebook">
              <FontAwesomeIcon icon={faFacebookSquare} />
            </a>
            <a href="https://www.instagram.com/manhattanfurnitureco/" target="_blank" rel="noopener noreferrer" title="Instagram">
              <FontAwesomeIcon icon={faInstagramSquare} />
            </a>
            <a href="https://www.linkedin.com/company/manhattan-furniture-ind-co-llc/" target="_blank" rel="noopener noreferrer" title="LinkedIn">
              <FontAwesomeIcon icon={faLinkedin} />
            </a>
          </div>
        </div>
      </div>

      <div className={classes.footerBottom}>
        <span className={classes.copyright}>
          {`© ${new Date().getFullYear()} First Number Furniture IND LLC. All rights reserved.`}
        </span>
        <span className={classes.tou}>
          By using this site you agree to our <span>Terms of Use</span>.
        </span>
      </div>
    </footer>
  );
}

export default Footer;
